export const pageNotFound = 'Page introuvable';
